import { useTranslation } from "react-i18next";
import { DutyCard } from "./DutyCard";

export const DutyList = ({ duties, employees, onDelete, onStatus }) => {
  const { t } = useTranslation();
  if (duties.length === 0) return <p className="text-sm text-muted-foreground" data-testid="duty-empty">{t("duty.empty")}</p>;

  const nameOf = (ids) =>
    (ids || [])
      .map((id) => employees.find((e) => e.id === id))
      .map((e) => e?.full_name || e?.email)
      .filter(Boolean)
      .join(" · ");

  return (
    <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3" data-testid="duty-list">
      {duties.map((d) => (
        <DutyCard key={d.id} duty={d} names={nameOf(d.employee_ids)} onDelete={onDelete} onStatus={onStatus} />
      ))}
    </div>
  );
};
